import { Injectable } from '@angular/core';

import { ChartConfigItem } from './config-item';
import { LegendConfig } from './legend-config';
import { VisualizationConfigs } from './visualization-configs';

export const enum LegendPosition {
    TOP = 'top',
    BOTTOM = 'bottom',
    RIGHT = 'right',
}

@Injectable()
export class LegendConfigurationService {
    private readonly inline = false;
    private readonly showCustom = true;

    getConfigFromUserPreference(preferences?: VisualizationConfigs): LegendConfig {
        const legend = this.getLegendConfig(preferences);

        if (preferences?.enableLegend) {
            legend.docked = preferences.legendPosition as LegendPosition || legend.docked;

            if (legend.nav && (legend.docked === LegendPosition.BOTTOM || legend.docked === LegendPosition.TOP)) {
                legend.nav.y = -5;
            }
        } else {
            legend.showCustom = false;
        }

        return legend;
    }

    private getLegendConfig(preferences?: VisualizationConfigs): LegendConfig {
        const mirroredValues = isMirroredBarChart(preferences) ? preferences?.configs?.mirroredValues ?? [] : [];
        // Restore this and delete line 38 after the widget migration is complete
        // const values = isChartConfigItemList(preferences?.configs?.values) ? preferences.configs.values : [];
        const values = preferences?.configs?.values as ChartConfigItem[] ?? [];

        return {
            inline: this.inline,
            docked: LegendPosition.RIGHT,
            showCustom: this.showCustom,
            type: 'circle',
            nav: { x: 12, y: 0 },
            rectSize: 7,
            values: preferences?.configs?.slicers?.length === 0 || isMirroredBarChart(preferences) ?
                [...values, ...mirroredValues]
                : undefined,
        };
    }
}

function isMirroredBarChart(preferences?: VisualizationConfigs): boolean {
    return preferences?.visualizationType === 'VERTICAL_MIRRORED_BAR_CHART';
}

// Restore this after the widget migration is complete
// function isChartConfigItemList(items: ValueConfigItem[] | undefined): items is ChartConfigItem[] {
//     if (!items) {
//         return false;
//     }

//     return items.every((item) => !('alignment' in item));
// }
